import React from 'react';
import Button from '@dtci/spellbook/Button';

export const FunctionsCellRenderer = (onLoadTemplate, onDeleteTemplate) => {
    return function Renderer({ data }) {

        return (
            <span style={{ display: 'flex', gap: 8 }}>
                <Button
                    sizeType="small"
                    styleType="link"
                    onClick={() => onLoadTemplate(data)}
                    iconType="fa-solid fa-eye"
                />
                <Button
                    sizeType="small"
                    styleType="link"
                    onClick={() => onDeleteTemplate(data)}
                    iconType="fa-solid fa-trash"
                    style={{ color: 'var(--sbt-red-60, #d32f2f)' }}
                />
            </span>
        );
    };
};
